// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export const throttle: Function = (func: Function, delay: number) => {
  let lastTime = 0
  let timerId: ReturnType<typeof setTimeout>

  return function (this: unknown, ...args: unknown[]) {
    const currentTime = Date.now()

    if (currentTime - lastTime < delay) {
      clearTimeout(timerId)

      timerId = setTimeout(() => {
        lastTime = currentTime
        func.apply(this, args)
      }, delay)
    } else {
      lastTime = currentTime
      func.apply(this, args)
    }
  }
}
